import React from "react";
import { Box, Typography, TextField, useTheme } from "@mui/material";

const CustomInput = ({
  label,
  placeholder,
  isTextarea = false,
  rows = 4,
  error,
  helperText,
  FormHelperTextProps,
  ...props
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        width: "100%",
      }}
    >
      <Typography
        component="label"
        sx={{
          fontSize: "18px",
          fontWeight: "700",
          color: theme.palette.primary.title || "#1E2024",
        }}
      >
        {label}
      </Typography>

      <TextField
        fullWidth
        placeholder={placeholder}
        variant="outlined"
        multiline={isTextarea}
        rows={isTextarea ? rows : 1}
        error={error}
        helperText={helperText}
        FormHelperTextProps={{
          sx: {
            textAlign: FormHelperTextProps?.textAlign || "left",
            fontSize: "14px",
            fontWeight: "500",
            marginRight: 0,
            marginLeft: 0,
            ...FormHelperTextProps?.sx,
          },
        }}
        {...props}
      />
    </Box>
  );
};

export default CustomInput;
